import { Plus } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { Eyebrow } from "../components/Eyebrow";
import { PORTFOLIO } from "../data/site";

function FounderItem({ name, url }) {
  const [first, ...restWords] = name.split(" ");
  const rest = restWords.join(" ");
  const label = (
    <>
      <span key="first" className="inline-flex items-start gap-1.5">
        {first}
        <Plus className="mt-1 h-4 w-4 shrink-0 text-[#A27B5B] transition-transform duration-300 group-hover:rotate-90" />
      </span>
      {rest ? (
        <span key="rest" className="block">
          {rest}
        </span>
      ) : null}
    </>
  );

  return (
    <li>
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`portfolio-${name}`}
          className="group text-[1.25rem] font-medium tracking-tight text-[#2C3639] transition-colors duration-300 hover:text-[#A27B5B] sm:text-[1.4rem]"
        >
          {label}
        </a>
      ) : (
        <span
          data-testid={`portfolio-${name}`}
          className="group text-[1.25rem] font-medium tracking-tight text-[#2C3639] sm:text-[1.4rem]"
        >
          {label}
        </span>
      )}
    </li>
  );
}

export function PeopleSection() {
  return (
    <section
      data-testid="people-section"
      className="mx-auto max-w-[760px] px-6 py-[112px] sm:px-8 sm:py-[160px]"
    >
      <Reveal data-testid="item-people">
        <Eyebrow as="h2">Investing in people</Eyebrow>
        <div className="mt-7 space-y-6 text-[1.18rem] leading-[1.65] text-[#2C3639] sm:text-[1.35rem]">
          <p>
            We’re entrepreneurs by nature, having spent two decades
            building, scaling, and successfully exiting businesses of our
            own. Along the way, we developed a deep appreciation for the
            people willing to take risks, solve problems, and create
            something from nothing.
          </p>
          <p className="font-bold text-[#A27B5B]">That’s who we invest in.</p>
          <p>
            Today, we invest our own capital alongside founders and
            operators we believe in. We tend to get involved early, when
            experience, perspective, and a trusted sounding board can make a
            meaningful difference.
          </p>
          <p>
            The strongest communities, relationships, and ideas are often
            built around a table. When it’s helpful, we’ll take a seat at
            yours. When it’s not, we’ll stay out of the way.
          </p>
          <p>
            We invest because we believe in elevating founders who have the
            grit, vision, and conviction to build something exceptional.
          </p>
        </div>
      </Reveal>

      <Reveal className="mt-[88px] sm:mt-[112px]" delay={80}>
        <Eyebrow>A few of the founders we back</Eyebrow>
        <ul
          data-testid="portfolio-list"
          className="mt-10 grid grid-cols-1 gap-x-10 gap-y-7 sm:grid-cols-2 lg:grid-cols-4"
        >
          {PORTFOLIO.map(({ name, url }) => (
            <FounderItem key={name} name={name} url={url} />
          ))}
        </ul>
      </Reveal>
    </section>
  );
}
